<template>
    <div>
        <div class="columns">
            <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-mobile">
                <p id="back-to-results" class="is-size-7">
                    <a @click="historyBack()"><i class="fas fa-arrow-left"></i> BACK TO REPORTED REVIEWS</a>
                </p>
            </div>
        </div>
        <div class="level" v-if="is_loading">
            <div class="level-left">
                <span class="button is-white has-text-right preloader"
                      :class="{'is-loading': is_loading}"></span>
            </div>
        </div>
        <div class="columns is-multiline" v-if="!is_loading">
            <div class="column is-full-mobile padding-bottom-0">
                <div class="title is-marginless is-paddingless">
                    Review about
                    <a :href="getBusinessConsumerURL" target="_blank" class="has-text-underlined color-2aabe1">{{ asText(business.name, 80) }}</a>
                </div>
            </div>
            <div class="buttons">
                <span @click="deleteReviewStatus=true" v-if="statusId!='2'" class="button is-button-grey-outline delrev">DELETE REVIEW</span>
                <span @click="republishReview" v-if="statusId=='2'" class="button is-button-grey-outline reprev">REPUBLISH</span>
            </div>
        </div>

        <!-- reassign review history section -->
        <div v-if="reassignReviews && !is_loading" class="review-reassign is-italic">
            <ul>
                <li v-for="(reviewReassign, index) in reassignReviews" :key="index">
                    <small>Reassigned on
                        {{ reviewReassign.created_at | prettyDateTime }} from {{reviewReassign.business_name | getBusinessName}} by {{getFullName(reviewReassign)}}
                    </small>
                </li>
            </ul>
        </div>
        <!-- delete review message section -->
        <div v-if="!is_loading" class="review-reassign is-italic">
            <ul v-if="reviewsLogList">
                <li :key="index" v-for="(reviewLog,index) in reviewsLogList"><small>{{ getLogMessage(reviewLog) }}</small></li>
            </ul>
        </div>

        <div class="columns">
          <div class="column is-three-fifths-desktop">
            <div class="card custom-panel">
                <header class="card-header">
                  <p class="card-header-title has-text-weight-normal"> <img src="/static/img/report.svg" width="40" height="40" alt="Report Review" /> &nbsp;&nbsp; Reported Review</p>
                  <!--Drop Down For Reported Status-->
                  <p class="card-header-icon has-text-weight-normal" v-if="reportReviewStatus !=='RESOLVED'" >
                    <dropdown dropdownName="report_status" ref="report_status"
                      :items="changeReportStatus" btnMinWidth="button-width-200px"
                      :select-first-item-on-mount="selectFirstOption"
                      class="is-fullwidth"
                      :place-holder="filterReportedStatus"
                      :review-report="reportReviewStatus"
                      v-on:changed="updateReportedStatus($event)"
                      v-if="reportReviewStatus"
                    ></dropdown>
                  </p>
                  <p v-else class="card-header-icon has-text-weight-normal">Resolved</p>
                  <!---End Drop Down For Reported Status--->
                </header>
                <div class="card-content has-text-weight-normal">
                  <div class="columns is-desktop clear-floats" v-show="!is_loading">

                    <div class="column is-6">
                      <p>
                        <small>Reported Date:</small>
                        <span class="has-text-weight-bold">{{ reportedReviewData.created_at | prettyDateTime }}</span>
                      </p>

                      <p>
                        <small>Reporter:</small>
                        <span class="has-text-weight-bold">{{ getReporterFullName(reportedReviewData) }}</span> <span> ({{ getReporterType(reportedReviewData) }}) </span>
                      </p>

                      <p>
                        <small>Contact details:</small>
                        <span class="has-text-weight-bold">{{ reportedReviewData.reporter_email }}</span> <br/>
                        <span class="has-text-weight-bold">{{ reportedReviewData.reporter_contact }}</span>
                      </p>

                    </div>

                    <div class="column is-6">
                      <p>
                        <small>Reason:</small> <span class="has-text-weight-bold">{{ reportedReviewData.reasonCategory }}</span> <br/>
                        <span>{{ reportedReviewData.report_reason }}</span>
                      </p>
                    </div>

                  </div>
                </div>
              </div>

            <!-- Review Messages -->
            <div class="card main-card custom-panel">
              <header class="card-header">
                <p class="card-header-title has-text-weight-normal" v-text="review.title"></p>
                <div class="card-header-icon has-text-weight-normal is-left is-hidden-mobile" aria-label="rating">
                  <rating :stars="review.rating"></rating>
                </div>
              </header>
              <div class="card-content">
                <article class="media">
                  <figure class="media-left is-hidden-mobile">
                    <avatar :size="45" :username="authorDisplayName"></avatar>
                  </figure>
                  <div class="media-content is-clearfix">
                    <nav class="level is-mobile">
                      <div class="level-left">
                        <div class="level-item is-hidden-tablet"><avatar :size="30" :username="authorDisplayName"></avatar></div>
                        <div class="level-item has-text-weight-bold" v-text="authorDisplayName"></div>
                      </div>
                      <div class="level-right">
                        <div class="level-item is-hidden-tablet"><rating :stars="review.rating"></rating></div>
                        <div class="level-item has-text-grey is-italic is-hidden-mobile has-text-right">
                                            <span>
                                                <small>{{ showPostedLog(review.created_at) }}</small>
                                                <small v-html="showUpdatedLog(review)"></small>
                                            </span>
                        </div>
                      </div>
                    </nav>
                    <p class="has-text-grey is-italic is-hidden-tablet">
                      <small>{{ showPostedLog(review.created_at) }}</small>
                      <small v-html="showUpdatedLog(review)"></small>
                    </p>
                    <div class="content" v-html="review.content"></div>
                    <review-attachments :attachments="review.attachments"></review-attachments>
                    <a href="#" class="has-text-underlined color-2aabe1 is-pulled-right editLink" @click.prevent="openReviewEditModal(
                  {
                    title: review.title,
                    content: review.content,
                    rating: review.rating
                  },
                  {
                    type:'review',
                    id: review.id
                  })">Edit</a>
                  </div>
                </article>
                <!-- Messages -->
                <template v-if="messages && messages.length > 0" v-for="message in messages">
                  <article class="media" v-if="message && !('nps_rating' in message)">
                    <figure class="media-left is-hidden-mobile" v-if="message.message_owner === 1">
                      <avatar :size="45" :username="authorDisplayName"></avatar>
                    </figure>
                    <div class="media-left business-logo is-hidden-mobile" v-else><img :src="getBusinessIcon(business)" /></div>
                    <div class="media-content">
                      <nav class="level is-mobile" :class="[{'padding-bottom-0 margin-bottom-0': message.message_owner === 2}]">
                        <div class="level-left">
                          <div class="level-item is-hidden-tablet">
                            <div class="level-item is-hidden-tablet" v-if="message.message_owner === 1"><avatar :size="30" :username="authorDisplayName"></avatar></div>
                            <div class="media-left business-logo-mobile" v-else><img :src="getBusinessIcon(business)" /></div>
                          </div>
                          <div class="level-item has-text-weight-bold" v-if="message.message_owner === 1" v-text="authorDisplayName"></div>
                          <div class="level-item has-text-weight-bold" v-else v-text="business.name"></div>

                        </div>
                        <div class="level-right">
                          <div class="level-item">
                                              <span class="has-text-right">
                                                  <span>
                                                      <span v-if="privateReply(message.message_type)" class="tag is-private is-rounded has-text-weight-bold">Private reply</span>
                                                      <small class="is-hidden-mobile">{{ showPostedLog(message.created_at) }}
                                                        <span v-if="message.message_owner === 2"> by {{message.userDisplayName}} </span>
                                                      </small>
                                                  </span>
                                                  <small class="is-hidden-mobile" v-html="showUpdatedLog(message)"></small>
                                                  <small class="has-text-grey is-italic" v-html="showDeleteLog(message)"></small>
                                              </span>
                          </div>
                        </div>
                      </nav>
                      <nav class="level is-mobile padding-top-0" v-if="message.message_owner === 2"></nav>
                      <p class="has-text-grey is-italic is-hidden-tablet">
                        <small>{{ showPostedLog(message.created_at) }}
                          <span v-if="message.message_owner === 2"> by {{message.userDisplayName}} </span>
                        </small>
                        <small v-html="showUpdatedLog(message)"></small>
                        <small class="has-text-grey is-italic" v-html="showDeleteLog(message)"></small>
                      </p>
                      <div class="content" v-html="message.body"></div>
                      <span v-if="!message.deleted_at" class="is-pulled-right">
                        <a href="#" class="has-text-underlined color-2aabe1 is-pulled-right editLink" @click.prevent="openReviewReplyEditModal(message.body, {id:message.id, type:'message', content:message.body})">Edit</a>
                        <a v-if="message.message_owner===2" href="#" class="has-text-underlined color-2aabe1 is-pulled-right editLink" @click.prevent="openDeleteReplyModal(message.id)">Delete</a>
                      </span>
                    </div>
                  </article>
                  <!-- nps detail section -->
                  <NPSDetails :nps="nps" :authorDisplayName="authorDisplayName" v-if="message && ('nps_rating' in message)" />
                </template>
                <article v-if="messages.length === 0" class="media">
                  <figure class="media-left is-hidden-mobile is-45x45">&nbsp;</figure>
                  <div class="media-content">
                    <div class="content">Business has not replied.</div>
                  </div>
                </article>
              </div>
            </div>
          </div>

          <div class="column is-two-fifths-desktop">
            <reassign-review
                    :reviewAuthorData="{ uuid: author.uuid }"
                    :reviewPermalinkParam="reviewPermalink"
                    :reviewSlugParam="reportSlug"
                    :reportedReviewPage=true
                    :reportReviewBizDetailData = "{
                    reportId: reportedReviewData.id,
                    reviewId: reportedReviewData.review_id
                    }"
                ></reassign-review>

            <!-- Internal notes -->
            <internal-notes :review-id="parseInt(reviewId, 10)"></internal-notes>

            <!-- Additional information -->
            <div class="card custom-panel">
              <header class="card-header">
                <p class="card-header-title has-text-weight-normal">Reviewer information:</p>
                <a href="javascript:void(0)" @click="getReviewerURL" class="has-text-underlined reviewer-profile-link color-2aabe1">
                  View profile
                </a>
              </header>
              <div v-if="showInfo" class="card-content has-text-weight-normal">
                <p>
                  <small>Full name:</small><br/>
                  <span class="has-text-weight-bold" v-text="author.fullName"></span>
                </p>
                <p>
                  <small>Username:</small><br/>
                  <span class="has-text-weight-bold" v-text="author.username"></span>
                </p>
                <p>
                  <small>Contact details:</small><br/>
                  <span class="has-text-weight-bold" v-text="author.email"></span>
                  <br>
                  <span class="has-text-weight-bold" v-text="author.phone"></span>
                </p>
                <p>
                  <small>ID number:</small><br/>
                  <span class="has-text-weight-bold" v-text="author.id_number"></span>
                </p>
                <p>
                  <small>Reference number:</small><br/>
                  <span class="has-text-weight-bold" v-text="review.ref_number"></span>
                </p>
                <p>
                  <small>Where it happened:</small><br/>
                  <span class="has-text-weight-bold" v-text="review.incident_branch"></span>
                </p>
                <p>
                  <small>IP address:</small><br/>
                  <span class="has-text-weight-bold" v-text="review.reviewer_ip_address"></span>
                </p>
                <p>
                  <a :href="getCFReviewURL" target="_blank" class="has-text-underlined color-2aabe1">Review URL</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- review delete modal -->
        <div class="modal is-active" v-if="deleteReviewStatus">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head headnewcl">
                    <strong>Delete review</strong>
                    <!-- <p>Why is this review being removed?</p> -->

                </header>

                <section class="modal-card-body">
                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyReviewer"
                                    v-model="notifyReviewer"
                                    ref="notifyReviewer"
                                    @change="getCheckDisableStatus('reviewer')"
                            />
                            &nbsp; Notify reviewer
                        </label>
                    </div>
                    <div>
                        <textarea ref="revReason" :class="{ 'is-danger': notifyReviewer && reasonRevRequiredMessage && !deleteReviewerReason }" :disabled="getRevDisStatus" class="delete-reason " v-model="deleteReviewerReason" maxlength="350" rows="6"></textarea>
                        <p class="help is-danger" v-if="notifyReviewer && reasonRevRequiredMessage && !deleteReviewerReason">{{reasonRevRequiredMessage}}</p>
                    </div>

                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyBusiness"
                                    v-model="notifyBusiness"
                                    ref="notifyBusiness"
                                    @change="getCheckDisableStatus('business')"
                            />
                            &nbsp; Notify business
                        </label>
                    </div>
                    <div>
                        <textarea ref="bizReason" :class="{'is-danger': notifyBusiness && reasonBizRequiredMessage && !deleteBizReason }" :disabled="getBizDisStatus"  maxlength="350" rows="6" class="delete-reason " v-model="deleteBizReason"></textarea>
                        <p class="help is-danger" v-if="notifyBusiness && reasonBizRequiredMessage && !deleteBizReason">{{reasonBizRequiredMessage}}</p>
                    </div>

                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyCheck"
                                    v-model="notifyCheck"
                                    ref="notifyCheck"
                                    @change="getCheckDisableStatus('none')"
                            />
                            &nbsp; Delete review without notifying anyone
                        </label>
                    </div>
                    <!-- Content ... -->
                </section>

                <footer class="modal-card-foot delete-review-footer">

                    <button class="button" @click="deleteReviewStatus=false">CANCEL</button>
                    <button class="button" @click="deleteReviewDetails" :disabled="getDisabledStatus">DELETE</button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import misc from '../../mixins/misc.js'
  import moment from 'moment'
  import axios from 'axios'
  import Avatar from 'vue-avatar'
  import Rating from './../../components/Rating.vue'
  import ReassignReview from './../../widgets/ReassignReviewWidget.vue'
  import NPSDetails from './../../components/NPSDetails'
  import InternalNotes from './../../widgets/InternalNotesWidget.vue'
  import Dropdown from './../../components/DropDown.vue'
  import ReviewAttachments from './../../components/ReviewAttachments'

  export default {
    components: {
      Rating,
      Avatar,
      Dropdown,
      ReassignReview,
      NPSDetails,
      InternalNotes,
      ReviewAttachments
    },
    mixins: [misc],
    data () {
      return {
        authorDisplayName: '',
        is_loading: true,
        business: {},
        review: {},
        messages: {},
        author: {},
        notes: {},
        nps: {},
        showInfo: true,
        has_author_object_in_response: false,
        note: '',
        reportedReviewData: {},
        deleteReviewStatus: false,
        deleteBizReason: '',
        deleteReviewerReason: '',
        notifyCheck: false,
        notifyReviewer: false,
        notifyBusiness: false,
        reasonRevRequiredMessage: '',
        reasonBizRequiredMessage: '',
        modal_props: {},
        reviewsLogList: {},
        statusId: 0,
        reportReviewID: 0,
        reassignReviews: {},
        selectFirstOption: '',
        filterReportedStatus: '',
        reportReviewStatus: '',
        reportedStatus: [
          {
            name: 'In-progress',
            value: 'IN_PROGRESS'
          },
          {
            name: 'Resolved',
            value: 'RESOLVED'
          }
        ],
        bizSlugFromEvent: undefined
      }
    },
    mounted () {
      let that = this
      window.events.$on('addReassignReviews', function (bizSlug) {
        that.bizSlugFromEvent = bizSlug
        that.fetch()
        that.fetReviewActionHistory(bizSlug)
        that.fetReviewAssign(bizSlug)
        that.getCurrentReviewDetails()
      })
    },
    created () {
      this.fetch()
      this.fetReviewAssign(this.targetBizSlug)
      this.fetReviewActionHistory(this.getBusinessSlug)
      this.getCurrentReviewDetails()
      // Event when modal is submitted
      window.events.$on('editReview', this.editReview)
      window.events.$on('editReviewReply', this.editReviewReply)
      let that = this
      window.events.$on('deleteBusinessReply', function (data) {
        that.deleteReviewReply(data.messageId)
      })
    },
    destroyed () {
      window.events.$off('editReview')
      window.events.$off('editReviewReply')
      window.events.$off('deleteBusinessReply')
    },
    computed: {
      getBusinessSlug () {
        return this.targetBizSlug
      },
      getReviewPermalink () {
        return this.reviewPermalink
      },
      getBusinessConsumerURL () {
        return process.env.HP_APP_URL + `/${this.getBusinessSlug}`
      },
      targetBizSlug () {
        if (this.bizSlugFromEvent) {
          return this.bizSlugFromEvent
        }
        return this.$router.currentRoute.params.businessSlug
      },
      reviewPermalink () {
        return this.$router.currentRoute.params.reportedReviewSlug
      },
      reportSlug () {
        return this.$router.currentRoute.params.reportSlug
      },
      reviewId () {
        return this.$router.currentRoute.params.reviewId
      },
      getRevDisStatus () {
        return !this.notifyReviewer
      },
      getBizDisStatus () {
        return !this.notifyBusiness
      },
      getDisabledStatus () {
        if (this.notifyCheck || this.notifyReviewer || this.notifyBusiness) {
          return false
        } else {
          return true
        }
      },
      // Change dropdown status based on backend status
      changeReportStatus () {
        let status = {
          name: 'Reported',
          value: 'REPORTED'
        }
        if (this.reportReviewStatus === 'RE_OPENED') {
          status = {
            name: 'Re-opened',
            value: 'RE_OPENED'
          }
        }
        this.reportedStatus.unshift(status)
        if (this.reportReviewStatus === 'IN_PROGRESS') {
          this.reportedStatus.shift()
        }
        return this.reportedStatus
      },
      /**
       * Get CF review details URL
       *
       * @returns {string}
       */
      getCFReviewURL () {
        return `${process.env.HP_APP_URL}/${this.getBusinessSlug}/reviews/${this.reviewPermalink}`
      }
    },
    filters: {
      getBusinessName (bizName) {
        return bizName.replace(/^"(.+)"$/, '$1')
      }
    },
    methods: {
      // republish review
      republishReview () {
        const reviewPermalink = this.reviewPermalink
        let permLinkArr = reviewPermalink.split('-')
        if (permLinkArr.length > 0) {
          let params = {
            reviewPermalink: this.reviewPermalink,
            reportedReviewID: this.reportReviewID
          }
          axios.post(`/${this.targetBizSlug}/review/republish`, params)
              .then((response) => {
                this.fetch()
                let that = this
                setTimeout(function () {
                  that.fetReviewActionHistory(this.getBusinessSlug)
                }, 1000)
                flash(`Review has been successfully republished.`, 'is-success')
                this.recacheOnReviewTouched()
              })
              .catch(() => {
                flash(`There was an error republishing this review. Please try again.`, 'is-danger')
              })
        }
      },
      // get reviews action history
      fetReviewActionHistory (bizSlug) {
        axios.get(`/${bizSlug}/reviews/action/history/${this.reviewPermalink}`)
            .then((response) => {
              this.reviewsLogList = response.data
            })
            .catch((error) => {
              flash(error.message, 'is-danger')
            })
      },
      // get formatted reviews log message
      getLogMessage (reviewLog) {
        if (reviewLog.action === 'review.admin.republished') {
          return `Republished on ${this.getFormattedDate(reviewLog.updated_at)} by ${this.getFullName(reviewLog)}`
        }
        if (reviewLog.action === 'review.admin.deleted') {
          return `Deleted on ${this.getFormattedDate(reviewLog.updated_at)} by ${this.getFullName(reviewLog)}`
        }
      },
      /*
      * return user full name
      *
      * @return string
      * @param user
      */
      getFullName (user) {
        return `${user.first_name}` + ' ' + `${user.last_name}`
      },
      /*
      * formatted review date
      * @return date
      * @param date
      */
      getFormattedDate (date) {
        return moment(date).format('DD-MM-YYYY HH:mm')
      },
      // call when any checkbox get clicked
      getCheckDisableStatus (type) {
        switch (type) {
          case 'reviewer':
            this.notifyCheck = false
            if (this.notifyReviewer) {
              this.$refs.notifyCheck.disabled = true
              this.$refs.revReason.disabled = false
              this.$refs.revReason.focus()
            } else if (!this.notifyBusiness) {
              this.$refs.notifyCheck.disabled = false
            }
            break
          case 'business':
            this.notifyCheck = false
            if (this.notifyBusiness) {
              this.$refs.notifyCheck.disabled = true
              this.$refs.bizReason.disabled = false
              this.$refs.bizReason.focus()
            } else if (!this.notifyReviewer) {
              this.$refs.notifyCheck.disabled = false
            }
            break
          case 'none':
            this.notifyReviewer = false
            this.notifyBusiness = false
            if (this.notifyCheck) {
              this.$refs.notifyReviewer.disabled = true
              this.$refs.notifyBusiness.disabled = true
            } else {
              this.$refs.notifyReviewer.disabled = false
              this.$refs.notifyBusiness.disabled = false
            }
            break
          default:
            this.notifyReviewer = false
            this.notifyBusiness = false
            this.notifyCheck = false
        }
      },
      getCurrentReviewDetails () {
        axios.get(`/admin/${this.targetBizSlug}/reviews/${this.getReviewPermalink}`)
        .then(response => {
          if (response.data.reportedReviewData) {
            this.reportReviewStatus = response.data.reportedReviewData.status
            this.reportReviewID = response.data.reportedReviewData.id
          }
          let statusStringify = this.reportReviewStatus.replace('_', '-').toLowerCase()
          this.filterReportedStatus = statusStringify.charAt(0).toUpperCase() + statusStringify.slice(1)
          this.statusId = response.data.status_id
        })
        .catch(() => {
          this.deleteReviewStatus = false
        })
      },
      // delete review
      deleteReviewDetails () {
        const reviewPermalink = this.reviewPermalink
        let permLinkArr = reviewPermalink.split('-')
        if (permLinkArr.length > 0) {
          if (this.notifyBusiness && !this.deleteBizReason) {
            this.reasonBizRequiredMessage = `Please enter a reason`
          } else if (this.notifyReviewer && !this.deleteReviewerReason) {
            this.reasonRevRequiredMessage = `Please enter a reason`
          } else {
            let params = {
              notifyStatus: this.notifyCheck,
              notifyReviewer: this.notifyReviewer,
              notifyBusiness: this.notifyBusiness,
              deleteBizReason: this.deleteBizReason,
              deleteReviewerReason: this.deleteReviewerReason,
              reportedReviewID: this.reportReviewID
            }
            let reviewId = permLinkArr[permLinkArr.length - 1]
            axios.post(`/${this.targetBizSlug}/review/delete/${reviewId}`, params)
                .then((response) => {
                  this.fetch()
                  this.getCurrentReviewDetails()
                  let that = this
                  setTimeout(function () {
                    that.fetReviewActionHistory(this.getBusinessSlug)
                  }, 3000)
                  this.notifyCheck = false
                  this.notifyReviewer = false
                  this.notifyBusiness = false
                  this.deleteBizReason = ''
                  this.deleteReviewerReason = ''
                  this.deleteReviewStatus = false
                  flash(`Review has been successfully deleted.`, 'is-success')

                  this.recacheOnReviewTouched()
                })
                .catch(() => {
                  this.deleteReviewStatus = false
                  flash(`There was an error deleting this review. Please try again.`, 'is-danger')
                })
          }
        }
      },

      // Update reported review status
      updateReportedStatus (event) {
        if (!event.triggeredOnMount) {
          let params = {
            reportId: this.reportedReviewData.id,
            status: event.value
          }
          axios.post(`/reported-reviews/update-reported-status`, params)
            .then(response => {
              this.reportId = ''
              this.status = ''
              this.reportReviewStatus = response.data.data
              if (this.reportReviewStatus === 'IN_PROGRESS') {
                this.reportedStatus.shift()
              }
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': response.data.message,
                  'displayedMessage': response.data.message
                }
              })
            })
            .catch(() => {
              const flashMsg = 'Error while updating this report. Please try again later.'
              flash(flashMsg, 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to update reported status',
                  'displayedMessage': flashMsg
                }
              })
            })
        }
        },

      async fetch () {
        this.is_loading = true
        const businessDetailRequest = axios(`/business/${this.targetBizSlug}`)
        const reviewDetailRequest = axios(`/admin/${this.targetBizSlug}/reviews/${this.getReviewPermalink}`)

        try {
          const [businessDetailResponse, reviewDetailResponse] = await Promise.all([businessDetailRequest, reviewDetailRequest])
          this.business = businessDetailResponse.data
          this.is_loading = false
          this.showReviewDetail(reviewDetailResponse)
        } catch (error) {
          this.is_loading = false
        }
      },
      showReviewDetail ({data}) {
        this.reportedReviewData = data.reportedReviewData

        if ('revision' in data) {
          this.review.revision = data.revision
        }
        this.has_author_object_in_response = typeof data.author !== 'undefined'
        if (this.has_author_object_in_response) {
          this.author.name = data.author.name ? data.author.name : 'Not provided'
          this.author.username = data.author.username ? data.author.username : 'Not provided'
          this.author.email = data.author.email ? data.author.email : 'Not provided'
          this.author.mobile = data.author.phone ? data.author.phone : 'Not provided'
          this.author.id_number = data.author.id_number ? data.author.id_number : 'Not provided'
          this.author.fullName = data.author.fullName ? data.author.fullName : 'Not provided'
          this.author.phone = data.author.phone ? data.author.phone : 'Not provided'
          this.author.id = data.author.id ? data.author.id : 'undefined'
          this.review.ref_number = this.getIncidentReference(data.incident_ref_number, data.incident_id_number, data.incident_account_number)
          this.author.uuid = data.author.user_uuid
        }
        this.review.id = data.id
        this.review.title = data.review_title
        this.review.permalink = data.permalink
        this.review.slug = data.slug
        this.review.content = data.review_content
        this.review.attachments = data.attachments
        this.review.review_content_snippet = data.review_content
        this.review.created_at = data.created_at
        this.statusId = data.status_id
        this.messages = data.messages || []
        this.notes = data.notes
        this.nps = data.nps
        this.review.rating = data.review_rating
        this.authorDisplayName = data.authorDisplayName
        this.review.incident_branch = data.incident_branch !== '' ? data.incident_branch.trim() : 'Not provided'
        this.review.user_id = data.user_id
        this.review.reviewer_ip_address = data.reviewer_ip_address
        if (this.messages || data.nps) {
          this.messages = this.messages.concat(data.nps)
          this.messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        }
      },
      fetReviewAssign (bizSlug) {
        let that = this
        axios.get(`/${bizSlug}/reviews/reassign/history/${that.reviewId}`)
          .then((response) => {
            that.fetch()
            that.reassignReviews = response.data
          })
          .catch((error) => {
            flash(error.message, 'is-danger')
          })
      },
      historyBack () {
        let page = this.$route.query.page ? this.$route.query.page : 1
        this.$router.push(`/reported-review?page=${page}`)
      },
      /**
       * @param {object} data reported review object
       * @returns {string}
       */
      getReporterType (data) {
        if (data.bizUserName !== null && data.bizUserName !== undefined && data.bizUserName.length > 0) {
          return 'Business'
        }
        return 'User'
      },
      /**
       * @param {object} data Reported Review object
       * @returns {string} Reporter name
       */
      getReporterFullName (data) {
        if (data.bizUserName !== null && data.bizUserName !== undefined && data.bizUserName.length > 0) {
          return data.bizUserName
        } else if (data.reviewerName !== null && data.reviewerName !== undefined && data.reviewerName.length > 0) {
          return data.reviewerName
        } else if (data.reporter_name !== null && data.reviewerName !== undefined && data.reporter_name.length > 0) {
          return data.reporter_name
        } else {
          return '(Not available)'
        }
      },
      /**
       * Get reviewer profile url
       *
       * @returns {string}
       */
      getReviewerURL () {
        let route = this.$router.resolve({path: `/reviewer-detail/${this.review.user_id}`})
        window.open(route.href, '_blank')
      },
      /**
       * Delete Review Reply
       * @param {Integer} messageId Reply or Message Id
       * @returns {void}
       */
      deleteReviewReply (messageId) {
        axios.delete(`/admin/reply/${messageId}`)
          .then((response) => {
            this.displaySuccessMsg('Business reply has been successfully deleted. ', 'Successfully deleted review reply from reported reviews')
            this.fetch()
            this.getCurrentReviewDetails()
            let that = this
            setTimeout(function () {
              that.fetReviewActionHistory(this.targetBizSlug)
            }, 3000)
          })
          .catch((error) => {
            this.displayErrMsg(error, 'Failed to delete this review reply', error.message)
          })
      }
    }
  }
</script>

<style scoped>
  .card-content p:not(:last-child) {
    margin-bottom: 20px;
  }

    .tag.is-private {
        background-color: #c4cbd1;
        color: #58595b;
        font-size: 0.65rem;
    }

    article.media {
        font-size: 0.85rem;
    }

    .media + .media {
        border-top: 1px solid #8a8c91;
        margin-top: 2rem;
        padding-top: 2rem;
    }

    .media-content > .level {
        padding-top: 12px;
    }

    select, .select:not(.is-multiple) {
        height: 2.5rem;
        border-radius: 0;

    }

    .select select:not([multiple]) {
        padding-right: 6.5em;
    }

    .main-card .card-content {
        padding-bottom: 2rem;
    }

    .dropdown-item > a {
        color: #4a4a4a;
    }

    .dropdown.is-fullwidth, .dropdown.is-fullwidth > .dropdown-trigger, .dropdown-content.is-fullwidth > .dropdown-item, #action-menu-mobile {
        width: 100%;
    }

    .business-logo {
      margin-right: 1rem;
    }
    .business-logo img {
      height: 45px;
      width: 45px;
      border-radius: 50%;
    }
    p.card-header-icon.has-text-weight-normal {
      margin-right: 11px;
    }
    .card-header-icon .width-180 {
      width: 155px;
      margin-right: 30px;
    }
    @media screen and (min-width: 768px) {
        .level-right > .level-item > .tag::after {
            content: ' '
        }

        .tag.is-private {
            margin-right: 12px;
        }
    }

    @media screen and (max-width: 767px) {
        .business-logo-mobile {
            margin-right: 0;
        }

        .business-logo-mobile img {
            height: 30px;
            width: 30px;
            border-radius: 50%;
        }
    }

    #back-to-results > a {
        color: #2aabe1;
    }

    .is-45x45 {
        width: 45px;
        height: 45px;
    }

    .review-reassign {
        margin-left: 14px;
        font-size: 0.875em;
    }
    .delete-review{
        float:right;
    }
    .delete-reason{
        width: 100% !important;
        resize: none;
        padding: 10px;
        font-size: .85em !important;
        color: #8a8c91;
    }
    .modal-card-foot > button{
        float: right;
    }

    .headnewcl{
        flex-direction:column;
    }
    .headnewcl p{
        text-align:left;    display: block;
        width: 100%;
    }
    .btninline{
        display:flex;justify-content:space-between;
    }
    .delete-review button{
        margin-top:10px;
        padding: 4px;
        border-radius: 5px;
    }
    .delete-review-footer{
        display: flex;
        justify-content: flex-end;
    }
    .modal-card-head {
        border-top: 5px solid #30AAE1;
        padding-top: 40px;
        border-bottom: none !important;
        background-color: #fff;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .modal-card-foot {
        border-top: none !important;
        background-color: #fff;
        border-radius: none !important;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .notify-check-section {
        margin-top: 13px;
        margin-bottom: 10px;
    }
    textarea {
        font-size: .85em !important;
    }
    textarea.is-danger {
        border-color: #ff3860;
    }
    .buttons .delrev, .buttons .reprev {
        margin-right: 13px;
    }
    .reviewer-profile-link {
        display: flex;
        align-items: center;
        padding-right: 5px;
        font-size: 0.85rem;
    }
    .editLink {
        margin-right: 0.75rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/reported-reviews/ReportedReviewDetails.vue